import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { FAQ_ITEMS } from './constants';
import { PageTitle } from '../root/components/common';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            width: '100%',
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 40,
        },
        pageContainer: {
            maxWidth: 1000,
            width: "100%"
        },
        container: {
            width: "100%",
            minHeight: 500,
            "& > iframe": {
                height: "100%",
                width: "100%",
            }
        }
    }),
);

export default function Faq() {
    const classes = useStyles();
    const { locale } = useSelector(state => state.main)
    return (

        <div className={classes.root}>
            <div className={classes.pageContainer}>
                <PageTitle
                    title={locale.settings.faq}
                />
                {FAQ_ITEMS.map(item => {
                    return (
                        <Accordion key={item.id}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>{item.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <YoutubeEmbed videoId={item.id} title={item.title} />
                            </AccordionDetails>
                        </Accordion>)
                })}
            </div>
        </div>
    );
}

function YoutubeEmbed({ videoId, title }) {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <iframe
                width="853"
                height="480"
                src={`https://www.youtube.com/embed/${videoId}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={title}
            />
        </div>
    )
};